// Modèle de données pour les dépenses immobilières

export interface ExpenseImmobilier {
  id: number;
  reference: string;

  // Lien avec le bien ou autre
  propertyId?: number;
  propertyReference?: string;
  propertyTitle?: string;
  maintenanceId?: number; // Si lié à une maintenance

  // Informations de la dépense
  type: ExpenseType; // 'maintenance' | 'taxe' | 'assurance' | 'charges' | 'amenagement' | 'autre'
  category: string; // Catégorie détaillée
  title: string;
  description: string;

  // Montants
  amount: number;
  taxAmount?: number; // TVA ou autres taxes
  totalAmount: number; // Montant total incluant taxes

  // Période
  expenseDate: Date;
  periodStart?: Date; // Pour les dépenses périodiques
  periodEnd?: Date;

  // Paiement
  paymentMethod?: PaymentMethod; // 'virement' | 'cheque' | 'especes' | 'carte' | 'autre'
  paymentDate?: Date;
  paymentStatus: PaymentStatus; // 'non_paye' | 'partiel' | 'paye' | 'en_retard'

  // Fournisseur/Prestataire
  providerId?: number;
  providerName?: string;
  providerPhone?: string;
  providerEmail?: string;

  // Documents
  invoiceUrl?: string;
  receiptUrl?: string;
  documents?: ExpenseDocument[];

  // Répartition
  isRecoverable: boolean; // Récupérable sur le locataire
  recoverableAmount?: number;

  // Métadonnées
  createdAt: Date;
  updatedAt: Date;
  createdBy?: number;
  updatedBy?: number;

  // Notes
  notes?: string;
}

export type ExpenseType = 'maintenance' | 'taxe' | 'assurance' | 'charges' | 'amenagement' | 'foncier' | 'copropriete' | 'syndic' | 'autre';
export type PaymentMethod = 'virement' | 'cheque' | 'especes' | 'carte' | 'prelevement' | 'autre';
export type PaymentStatus = 'non_paye' | 'partiel' | 'paye' | 'en_retard';

export interface ExpenseDocument {
  id: number;
  type: string; // 'facture' | 'recu' | 'devis' | 'autre'
  name: string;
  url: string;
  uploadDate: Date;
}

// Exemple de données
export const SAMPLE_EXPENSES: ExpenseImmobilier[] = [
  {
    id: 1,
    reference: 'EXP-2024-001',
    propertyId: 1,
    propertyReference: 'APT-2024-001',
    propertyTitle: 'Appartement moderne 3 pièces',
    maintenanceId: 1,
    type: 'maintenance',
    category: 'Réparation plomberie',
    title: 'Réparation robinet cuisine',
    description: 'Réparation de la fuite au robinet de la cuisine',
    amount: 145,
    taxAmount: 29,
    totalAmount: 174,
    expenseDate: new Date('2024-01-16'),
    paymentMethod: 'virement',
    paymentDate: new Date('2024-01-20'),
    paymentStatus: 'paye',
    providerName: 'Plomberie Express',
    isRecoverable: false,
    createdAt: new Date('2024-01-16'),
    updatedAt: new Date('2024-01-20')
  },
  {
    id: 2,
    reference: 'EXP-2024-002',
    propertyId: 2,
    propertyReference: 'MAI-2024-002',
    propertyTitle: 'Villa avec jardin et piscine',
    type: 'assurance',
    category: 'Assurance habitation',
    title: 'Prime assurance annuelle',
    description: 'Prime d\'assurance habitation pour l\'année 2024',
    amount: 1200,
    taxAmount: 240,
    totalAmount: 1440,
    expenseDate: new Date('2024-01-01'),
    periodStart: new Date('2024-01-01'),
    periodEnd: new Date('2024-12-31'),
    paymentMethod: 'prelevement',
    paymentDate: new Date('2024-01-01'),
    paymentStatus: 'paye',
    providerName: 'Assurance Maison',
    isRecoverable: false,
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01')
  }
];

